import React, {useEffect, useState} from 'react';
import axios from "axios";
import {connect} from "react-redux";
import {IntlProvider} from 'react-intl';
// import en from "react-intl/locale-data/en";
import Papa from "papaparse";
import Config, {AVAILABLE_LANGUAGES, IS_LIXIL_SERVERS} from "./config";
import {baseAssetsPath} from "./bvcomponents/assets";
import {
  hardCodeIsAmericanImport, hardCodeIsAmericanStandard,
  hardCodeIsCaesarStone, hardCodeIsDalTile,
  hardCodeIsEncore,
  hardCodeIsGraniteTransformationUK,
  hardCodeIsLowes, hardCodeIsMcDermott, hardCodeIsModerno
} from "./misc/fabricatorHardcode";
import {usePrevious} from "./misc/helperHooks";
// addLocaleData([...en]);

export let TRANSLATES = {};

export const fakeIntl = {
  formatMessage: ({id}) => {
    return TRANSLATES[id]
  }
}

export const isEnglish = (locale) => {
  return (locale !== "fr-FR") && (locale !== "pl-PL") && (locale !== "es-ES")
}

const getCustomJson = async (fileName = "") => {
  try {
    const customJsonResponse = await axios.get(`${baseAssetsPath}translates/custom/${fileName}.json?v=1.0.0`);
    if (customJsonResponse && customJsonResponse.data) {
      return customJsonResponse.data
    }
    return {}
  } catch (e) {
    console.log("couldn't set translate", e);
    return {}
  }
}

const TranslatesProvider = (props) => {
  const {language, children, wasCreatedFromFabricator} = props;
  const [translations, setTranslations] = useState(null);
  const [renderLanguage, setRenderLanguage] = useState(language);

  const prevLanguage = usePrevious(language);
  const prevWasCreatedFromFabricator = usePrevious(wasCreatedFromFabricator);

  const parseTranslatesResponse = (response) => {
    // handle success
    let trans = {}
    Papa.parse(response.data, {
      complete: (results) => {
        // console.log("Finished:", results.data);
        results.data[0].forEach((locale) => {
          if (locale !== "key") {
            trans[locale] = {};  // simple create an empty objects for each locale
          }
        });
        results.data.forEach((translatesArray, translatesArrayIndex) => { // vertical forEach
          if (translatesArrayIndex) { // not 0 (the first key line)
            const key = translatesArray[0]; // key, for ex. login.email
            translatesArray.forEach((translateValue, translateValueIndex) => { // horizontal forEach
              if (translateValueIndex) { // skip first key
                const locale = results.data[0][translateValueIndex]; // get first line and locale index
                trans[locale][key] = translateValue || translatesArray[1] // translate from column or english column
              }
            });
          }
        });
      }
    });
    return trans
  }

  const getCustomTranslates = (transDoc, localeString) => {
    let trans = {};
    Object.keys(transDoc)
      .filter(key => key.includes(localeString))
      .forEach(key => {
        Object.keys(transDoc[key]).forEach((sharedName) => {
          if (sharedName) {
            trans[`transDoc.${key}.${sharedName.trim()}`] = transDoc[key][sharedName]
          }
        })
      });
    return trans
  };

  const loadTranslates = async () => {
    const responseMain = await axios.get(`${baseAssetsPath}translates/translates.csv?v=2.3.1`);
    let trans = parseTranslatesResponse(responseMain);
    let customTranslates = {};
    if (language === "en-AU") {
      trans["en-AU"] = {...trans["en-US"]}
      customTranslates = await getCustomJson( "en-AU");
    }
    if (hardCodeIsLowes()) {
      customTranslates = await getCustomJson( "Lowes");
      const responseLowes = await axios.get(`${baseAssetsPath}translates/translates_lowes.csv?v=1.13.1`)
      const doc = parseTranslatesResponse(responseLowes);
      trans["fr-FR"] = {...trans["fr-FR"], ...getCustomTranslates(doc, "_FR")};
      trans["pl-PL"] = {...trans["pl-PL"], ...getCustomTranslates(doc, "_PL")};
    } else if (hardCodeIsCaesarStone()) {
      console.log("fabricatorData.wasCreatedFromFabricator", wasCreatedFromFabricator);
      const jsonFile = wasCreatedFromFabricator === "QC Master Account CAN" ? "Caesarstone(CAN)" : "Caesarstone";
      customTranslates = await getCustomJson( jsonFile);
      const responseCaes = await axios.get(`${baseAssetsPath}translates/translates_caes_v1.csv`)
      const doc = parseTranslatesResponse(responseCaes);
      trans["fr-FR"] = {...trans["fr-FR"], ...getCustomTranslates(doc, "_FR")};
    } else if (hardCodeIsAmericanImport() || hardCodeIsAmericanStandard() || IS_LIXIL_SERVERS) {
      customTranslates = await getCustomJson( "Lixil");
    } else if (hardCodeIsGraniteTransformationUK()) {
      customTranslates = await getCustomJson( "GT_UK");
    } else if (hardCodeIsModerno()) {
      customTranslates = await getCustomJson( "Moderno");
    } else if (hardCodeIsMcDermott()) {
      customTranslates = await getCustomJson( "McDermott");
    } else if (hardCodeIsEncore()) {
      customTranslates = await getCustomJson( "Encore");
    } else if (hardCodeIsDalTile()) {
      customTranslates = await getCustomJson( "Daltile");
    }
    // const responseSqft = await axios.get(`${baseAssetsPath}translates/translates_sqft_v1.csv?ver=1.1.0`);
    // const transSqft = parseTranslatesResponse(responseSqft);
    // console.log("transSqft", transSqft);
    // for (let columnName in trans) {
    //   trans[columnName] = {...trans[columnName], ...transSqft[columnName]}
    // }
    // delete trans["Location"];
    // delete trans["Description & Context"];
    TRANSLATES = {...trans[language], ...customTranslates[language]};
    setTranslations(TRANSLATES);
    if (Config.isDevMode()) {
      console.log("all translates:", trans);
      console.log("current translates:", trans[language]);
    }
    setRenderLanguage(language); // change frontend after load
  }

  useEffect(() => {
    if ((language && (prevLanguage !== language)) || (wasCreatedFromFabricator && (prevWasCreatedFromFabricator !== wasCreatedFromFabricator))) {
      if(document.kvConfig.kioskMode) {
        KioskApp.PostMessage({type: 'getTranslates'}).then(res => loadTranslates({data: res})).catch(console.error);
      } else {
        loadTranslates().catch(console.error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, wasCreatedFromFabricator])

  return translations ? (
    <IntlProvider locale={renderLanguage}
                  messages={translations}
                  defaultLocale={AVAILABLE_LANGUAGES[0]}
                  onError={(error) => console.info(error)}>
      {children}
    </IntlProvider>
  ) : null

}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    wasCreatedFromFabricator: store.fabricatorState.wasCreatedFromFabricator,
    language: store.serverState.language,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TranslatesProvider)
